import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Footer from './Footer';
import ChatComponent from './ChatComponent';
import ProfileNavbar from './ProfileNavBar';
import NavigationBar from './NavigationBar';
import SignUpNavbar from './SignUpNavbar';
import { MdEmail } from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";
const ContactUs = () => {
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const storedUserData = JSON.parse(sessionStorage.getItem('user'));
        console.log("data", storedUserData);
        if (storedUserData) {
            setUserData(storedUserData);
            setFormData(prevState => ({
                ...prevState,
                firstName: storedUserData.firstName,
                lastName: storedUserData.lastName,
                email: storedUserData.email
            }));
        }
    }, []);

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();

        fetch('https://18.117.231.157/api/contactus', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
                alert('Your inquiry has been submitted successfully.');
                // Reset form data to initial state after successful submission
                setFormData({
                    firstName: userData ? userData.firstName : '',
                    lastName: userData ? userData.lastName : '',
                    email: userData ? userData.email : '',
                    message: ''
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };

    return (
        <div>
            {userData ? <ProfileNavbar /> : <NavigationBar />}
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <h1 className='contactuspageheaders'>Contact Us</h1>
            <br></br>
            <form className='loginform' onSubmit={handleFormSubmit}>
                
                <div className='names'>
                    <label htmlFor="firstName">First Name</label>
                    <input
                        type='text'
                        name="firstName"
                        placeholder='John'
                        className="input22"
                        required
                        value={formData.firstName}
                        onChange={handleChange}
                        readOnly={!!userData}
                    />
                    <label htmlFor="lastName">Last Name</label>
                    <input
                        type='text'
                        name="lastName"
                        placeholder='Doe'
                        className="input22"
                        required
                        value={formData.lastName}
                        onChange={handleChange}
                        readOnly={!!userData}
                    />
                </div>
                <label htmlFor="email">Email</label>
                <input
                    type="email"
                    name="email"
                    placeholder="johndoe@gmail.com"
                    className="input"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    readOnly={!!userData}
                />
                <label htmlFor="message">Message</label>
                <textarea
                    name="message"
                    className="input6"
                    placeholder="Enter your message here..."
                    required
                    value={formData.message}
                    onChange={handleChange}
                    style={{ height: '50px' }}
                />
                <br />
                <div className='goalsdiv'>
                    <button className="goals" type="submit">Submit Inquiry</button>
                </div>
                <br></br>
                <h1 className='contactuspageheaders'>You can also contact us at</h1>
                <div className='rowtype'>
                    <div className='coltype' style={{ textAlign: 'center' }}>
                    <MdEmail className='icon'/>
                    <h3 style={{ margin: '0'}}><a href='mailto:fitnesstrackingteam05@gmail.com' style={{color:'#2e2eea', backgroundColor:'white', borderRadius:'10px'}}>fitnesstrackingteam05@gmail.com</a></h3>
                    <p style={{margin:'0'}}>Monday - Friday : 9am - 5pm </p>
                    </div>
                    <div className='coltype' style={{ textAlign: 'center' }}>
                    <FaPhoneSquareAlt className='icon'/>
                    <h3 style={{ margin: '0'}}><a href='mailto:fitnesstrackingteam05@gmail.com' style={{color:'#2e2eea', backgroundColor:'white', borderRadius:'10px'}}>+1-(214) 885-1390</a></h3>
                    <p style={{margin:'0'}}>Monday - Friday : 9am - 5pm </p>
                    </div>
                    
                    

                </div>
                <br></br>
                <div className='rowtype' style={{ textAlign: 'center' }}>
                    <div className='coltype' style={{ textAlign: 'center' }}>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3356.375588498585!2d-97.11777202507687!3d32.72921618642862!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e7d12c7db6fc1%3A0x665a7cd85702867e!2sE.E.%20Davis%20Hall%2C%20701%20S%20Nedderman%20Dr%2C%20Arlington%2C%20TX%2076019!5e0!3m2!1sen!2sus!4v1744246139902!5m2!1sen!2sus"></iframe>
                    <h3 style={{ margin: '0'}}>📍 701 S Nedderman Dr, Arlington, TX 76019</h3>
                    <p style={{margin:'0'}}>Monday - Friday : 9am - 5pm </p>
                    </div>
                    

                </div>
            </form>

            <Footer />
            {userData ? <ChatComponent /> : null}

        </div >
    );
};

export default ContactUs;